<dx-page-header [options]="options"
                (appLogoClick)="onAppLogoClick()">

  <ng-container *dxPageHeaderNotificationBar="let item;">
    <a class="btn  pit-page-header__btn"
       title="{{item.title}}"
       (click)="onNotificationsClick()">
      <img class="pit-page-header__btn_icon" [src]="item.iconPath">
    </a>
  </ng-container>

  <ng-container *dxPageHeaderSettingsBar="let item;">
    <a class="btn  pit-page-header__btn"
       title="{{item.title}}"
       (click)="onSettingsClick()">
      <img class="pit-page-header__btn_icon" [src]="item.iconPath">
    </a>
  </ng-container>

  <ng-container *dxPageHeaderHelpBar="let item;">
    <a class="btn  pit-page-header__btn"
       title="{{item.title}}"
       (click)="onHelpClick()">
      <img class="pit-page-header__btn_icon" [src]="item.iconPath">
    </a>
  </ng-container>

  <ng-container *dxPageHeaderLogoutBar="let item;">
    <a class="btn  pit-page-header__btn"
       title="{{item.title}}"
       (click)="onLogoutClick()">
      <img class="pit-page-header__btn_icon" [src]="item.iconPath">
    </a>
  </ng-container>

  <ng-container *dxPageHeaderUserBar>
    <dx-user-bar></dx-user-bar>
  </ng-container>

</dx-page-header>
